import React from "react";

const GroupTabButton = ({ title, isActive, onClick }) => {
  return (
    <div className="group-tab-button">
      <div className={`group-tab-button__item ${isActive ? "active" : ""}`} onClick={onClick}>
        <div className="group-tab-button__title">{title}</div>
      </div>
    </div>
  );
};

export default GroupTabButton;
